import React from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../../types/state'

interface ProductsFilterProps {
  brandName: string
  searchQuery: string
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void
  onViewAll: () => void
  onAddProduct: () => void
}

const ProductsFilter: React.FC<ProductsFilterProps> = ({
  brandName,
  searchQuery,
  onSearch,
  onViewAll,
  onAddProduct
}) => {
  const { isSuperadmin } = useSelector((state: State) => state.user)
  return (
    <div className='products-header d-flex justify-content-between align-items-center mb-30'>
      <h3 className='products-header__title'>Produkty marki {brandName}</h3>
      <div className='products-filter d-flex'>
        <button
          className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                                      tw-text-teal
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                                    `}
          onClick={onViewAll}
        >
          <i className='fas fa-list mr-1' /> Wszystkie produkty
        </button>
        {isSuperadmin && <button
          className={`
                    tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                    tw-text-white
                    tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                  `}
          onClick={onAddProduct}
                         >
          <i className='fas fa-plus mr-1' /> Dodaj produkt
        </button>}
      </div>
    </div>
  )
}

export default ProductsFilter
